import { hasYesOrNo } from 'models/validate';
import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types';
import { setToStartOfMonth } from 'helpers/date';
import { isPVQForm } from 'helpers/form';
import { PsychologicalDiagnosisItemModel } from '../types';
import psychologicalTreatmentTypeValidator from '../../shared/treatmentTypeValidator';

const psychologicalDiagnosisItemValidator: ValidateJSModel<PsychologicalDiagnosisItemModel> = {
  Condition: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }

    if (options && options?.existingCondition) { return {}; }

    return {
      presence: true,
      hasValue: true,
    };
  },

  Diagnosed: (value, attributes, attributeName, options = {}) => {
    const { applicantBirthdate } = options;

    return {
      presence: true,
      daterange: { earliest: setToStartOfMonth(applicantBirthdate), latest: DEFAULT_LATEST },
    };
  },

  Treatment: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        presence: true,
        model: {
          validator: psychologicalTreatmentTypeValidator,
          requirePersonsName: true,
        }
      };
    }
    return { presence: true, model: { validator: psychologicalTreatmentTypeValidator } };
  },

  SameTreatmentFacility: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      if (options && options?.existingCondition) { return {}; }

      return {
        presence: true,
        hasValue: true
      };
    }

    return {};
  },

  Effective: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }

    if (options && options?.existingCondition) { return {}; }

    return {
      presence: true,
      hasValue: { validator: hasYesOrNo },
    };
  },

  Explanation: (value, attributes) => {
    if (attributes?.Effective && attributes?.Effective.value === 'No') {
      return {
        presence: true,
        hasValue: true,
      };
    }
    return {};
  },

  Comments: {},
};

export default psychologicalDiagnosisItemValidator;
